export default __webpack_public_path__ + "static/media/15.572c2890.png";